import * as React from "react"
import TextInput from "../TextInput";
import IStaticDataValue from "../../../../common/models/IStaticDataValue";

/**
 * Created by aditya on 16/07/18.
 */

export interface GoalMetricItemEditorProps {
    consultationType?: string,
    item: IStaticDataValue;
    onDataChange: (update: any) => any,
    fetchFitnessActivities?: (input: string) => Promise<any>;
}

class GoalMetricItemEditor extends React.Component<GoalMetricItemEditorProps> {
    constructor(props: GoalMetricItemEditorProps) {
        super(props)
    }

    render() {
        return (
            <div className="goal-metric-item-editor" >
                <div className={"goal-metric-item-editor-name"}>
                    <TextInput name={"goal-metric-goal"} />
                </div>
                <div className={"goal-metric-item-editor-current"}>
                    <TextInput name={"goal-metric-current"} />
                </div>
                <div className={"goal-metric-item-editor-min"}>
                    <TextInput name={"goal-metric-min"} />
                </div>
                <div className={"goal-metric-item-editor-max"}>
                    <TextInput name={"goal-metric-max"} />
                </div>
            </div>
        )
    }
}

export default GoalMetricItemEditor;